import { decryptData, encryptData } from "../../utils/encryption";
import { loaderInstance } from '../../context/LoaderContext';

const TOKEN_KEY = 'aqebtkyfslxhakertyfhbsdvcfgbf';

let tokenState = null;

/**
 * Sets the authentication token in both memory and localStorage.
 * @param {string|null} token - The token to store or null to remove it.
 */
export const setAuthToken = (token) => {
  tokenState = token;

  if (token) {
    encryptData(TOKEN_KEY, token);
  } else {
    localStorage.removeItem(TOKEN_KEY);
  }
};

/**
 * Gets the current authentication token.
 * Tries to restore from localStorage if not already in memory.
 * @returns {string|null} The token string or null if not found.
 */
export const getAuthToken = () => {
  if (!tokenState) {
    tokenState = decryptData(TOKEN_KEY);
  }
  return tokenState;
};


const API_BASE_URL = "/api";

const getCSRFToken = () => window.csrfToken || "";

/**
 * Makes a secure API request with auth, CSRF, and optional loading.
 *
 * @param {string} endpoint - API endpoint (e.g., "/activate-trip/")
 * @param {string} method - HTTP method (GET, POST, etc.)
 * @param {Object|null} body - Payload (optional)
 * @param {boolean} requiresAuth - Whether Authorization header is required
 *
 * @returns {Promise<Object>} Parsed JSON response or throws an error
 */
export const securedApiRequest = async (
  endpoint,
  method = "GET",
  body = null,
  requiresAuth = true
) => {
  const token = getAuthToken();

  if (requiresAuth && !token) {
    console.error("Unauthorized: No token available.");
    throw new Error("Unauthorized access. Please log in.");
  }

  const headers = {
    "Content-Type": "application/json",
    "X-CSRFToken": getCSRFToken(),
    ...(requiresAuth && { "Authorization": `Bearer ${token}` }),
  };

  try {
    loaderInstance.setLoading && loaderInstance.setLoading(true);

    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      method,
      headers,
      credentials: "include",
      body: body ? JSON.stringify(body) : null,
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data?.error || "An error occurred. Please try again.");
    }

    return data;
  } catch (error) {
    console.error(`API Error (${endpoint}):`, error);
    throw error;
  } finally {
    loaderInstance.setLoading && loaderInstance.setLoading(false);
  }
};
